export default class AppError extends Error {
	public readonly code: string;
	public readonly user_message: string;
	public readonly error: any;
	public readonly extra_data: any;

	constructor(
		code: string,
		user_message?: string | null,
		error?: any,
		extra_data: any = null
	) {
		super();

		// Pass the code as the standard error message
		this.code = code;
		this.user_message = user_message || "general.errors.general_error";
		this.error = error || null;
		this.extra_data = extra_data || undefined;

		// Without this, 'instanceof BackendError' will return false
		Object.setPrototypeOf(this, AppError.prototype);
	}
}
